
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import InsuranceService from '@/services/insurance.service';

enum SettlementStatus {
  NotTransferred = '未转账',
  TransferSuccess = '已转账',
  TransferFailed = '转账失败',
  Transferring = '转账中',
}

@Component
export default class InsuranceDrawer extends Vue {
  @lazyInject(InsuranceService)
  insuranceService!: InsuranceService;

  visible = false;

  tableData: any[] = [];

  settlementStatus = '--';

  statusList: any = {
    0: '未转账',
    1: '已转账',
    2: '转账失败',
    3: '转账中',
  };

  SettlementStatus = SettlementStatus;

  settlementTotalAmount = '--';

  columns = [
    {
      title: '高德订单号',
      dataIndex: 'amapOrderId',
      key: 'amapOrderId',
      align: 'center',
      width: 180,
    },
    {
      title: '门店名称',
      dataIndex: 'shopName',
      key: 'shopName',
      align: 'center',
      width: 120,
    },
    // {
    //   title: '服务内容',
    //   dataIndex: 'serviceContent',
    //   key: 'serviceContent',
    //   align: 'center',
    //   width: 120,
    // },
    {
      title: 'SKU',
      dataIndex: 'spuId',
      key: 'spuId',
      align: 'center',
      width: 120,
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: 120,
    },
    {
      title: '品牌门店',
      dataIndex: 'kaName',
      key: 'kaName',
      align: 'center',
      width: 120,
      customRender: (text: any) => text || '-',
    },
    {
      title: '数量',
      dataIndex: 'cnum',
      key: 'cnum',
      align: 'center',
      width: 80,
    },
    {
      title: '总核销次数',
      dataIndex: 'raw_count',
      key: 'raw_count',
      align: 'center',
      width: 110,
    },
    {
      title: '下单时间',
      dataIndex: 'ctime',
      key: 'ctime',
      align: 'center',
      width: 180,
    },
    {
      title: '核销金额',
      dataIndex: 'priceOrder',
      key: 'priceOrder',
      align: 'center',
      width: 100,
    },
    {
      title: '保险金额',
      dataIndex: 'premium',
      key: 'premium',
      align: 'center',
      width: 100,
    },
    {
      title: '是否自营品',
      dataIndex: 'self_operated',
      key: 'self_operated',
      align: 'center',
      width: 120,
      customRender: (text: number) => (text === 1 ? '是' : '否'),
    },
    {
      title: '核销时间',
      dataIndex: 'verifyts',
      key: 'verifyts',
      align: 'center',
      width: 180,
    },
  ];

  pagination = {
    total: 10,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: (total: number) => `共 ${total} 条`,
    onChange: this.onPageChange,
    onShowSizeChange: this.onSizeChange,
  };

  onPageChange(page: number) {
    this.pagination.current = page;
    this.loadData();
  }

  onSizeChange(_current: number, size: number) {
    this.pagination.pageSize = size;
    this.pagination.current = 1;
    this.loadData();
  }

  loadData() {
    // TODO: 调用接口获取分页数据
    // 根据 this.pagination.current 和 this.pagination.pageSize 请求数据
  }

  init(value?: any) {
    if (value) {
      // this.tableData = data.bill_id;
      const data = {
        bill_id: value.billId,
      };
      // this.tableData = data;
      this.getDatel(data);
    }
    this.visible = true;
  }

  async getDatel(val: any) {
    const res = await this.insuranceService.getInsuranceSettlementDetail(val);
    this.tableData = res.orderRawList;
    this.settlementTotalAmount = res.settle_amount;
    this.settlementStatus = this.statusList[res.settle_status];
  }

  onClose() {
    this.visible = false;
    this.tableData = [];
    this.settlementTotalAmount = '--';
    this.settlementStatus = '--';
  }

  getStatusColorClass() {
    switch (this.settlementStatus) {
      case SettlementStatus.NotTransferred:
        return 'status-not-transferred';
      case SettlementStatus.TransferSuccess:
        return 'status-transfer-success';
      case SettlementStatus.TransferFailed:
        return 'status-transfer-failed';
      case SettlementStatus.Transferring:
        return 'status-transferring';
      default:
        return '';
    }
  }
}
